import React, { useMemo, useState, useEffect } from "react";
import Notification, {iconTypeMapper} from "./Notification"
import classNames from "classnames";
import AnimateHeight from "react-animate-height";
import styles from "./Notification.module.scss";
import { Button, Span } from "./../../";
import _ from "lodash";

const values = {
    error: 4,
    warning: 3,
    info: 2,
    success: 1
};

const compare = (type1, type2) => {
    const val1 = values[type1] || 0;
    const val2 = values[type2] || 0;

    return val2 > val1 ? type2 : type1;
};

const  GroupedNotifications = ({maxType, notifications, className, style}) => {
    const [showAll, setShowAll] = useState(false);
    const Icon = iconTypeMapper[maxType].icon;
    const [closeNotification, setCloseNotification] = useState(
        Array(notifications.length).fill(false)
    );

    const notificationsCount = closeNotification.filter(value => value === false).length;

    const setNotificationClose = (index, value) => {
        // Create a new array with the same values as closeNotification
        const newCloseNotification = [...closeNotification];
        // Set the value at the specified index
        newCloseNotification[index] = value;
        // Update the state
        setCloseNotification(newCloseNotification);
    };
    useEffect(() => {
        setCloseNotification(Array(notifications.length).fill(false));
    }, [notifications]);

    const closeAllNotifications = () => {
        // Create a new array with the same values as closeNotification
        const newCloseNotification = [...closeNotification];
        _.times(notifications.length, (index) => {
            // Set true for all the indexes
            newCloseNotification[index] = true;
            setCloseNotification(newCloseNotification);
        });
    }

    return notificationsCount === 0 ? null :
    <AnimateHeight
        duration={ 400 }
        easing="cubic-bezier(.25,.8,.25,1)"
        height={ showAll ? "auto" : 67 }
        className={classNames(styles["grouped-container"], className, {[styles["active"]]: showAll})}
        style={style}
    >
        <>
            <div style={{ display: "flex" }}>
                {showAll && <Button variant="none" className={classNames(styles["show-less"], styles["margin-right"])} onClick={() => setShowAll(false)}>Show less</Button>}
                {showAll && <Button variant="none" className={styles["show-less"]} onClick={() => closeAllNotifications()}>Dismiss All</Button>}
            </div>
            {!showAll &&    <div className={classNames(styles["base"], styles[maxType])}>
                <Icon className={styles["icon"]}/>
                <div>
                    <Span bold>You have {notificationsCount} new {notificationsCount > 1 ? "notifications" : "notification"}.</Span>
                    <Button variant="text" onClick={() => setShowAll(true)} className={styles["show-more"]}>
                        See Details
                    </Button>
                </div>
                <div/>
            </div>}
            {showAll && <div>
                {notifications.map((notification, index) => {
                    return (!closeNotification[index] && <Notification key={index} onClose={() => setNotificationClose(index, true)} {...notification}>{notification.description}</Notification>)
                })}
            </div>}
        </>
    </AnimateHeight>
};

export default ({notifications: _notifications, className, style, isGlobal}) => {
    const {notifications, maxType} = useMemo(() => {
        const notifications = (_notifications || []).filter(notification => notification && notification.type);
        let maxType = null;
        notifications.forEach(({type}) => {
            maxType = compare(maxType, type);
        });

        return {notifications, maxType}
    }, [_notifications]);

    const _className = classNames(className, {[styles['global']]: isGlobal});

    if(notifications.length === 0) {
        return ""
    } else if (notifications.length < 4) {
        return <div className={_className} style={style}>
            {notifications.map((notification, index) => {
                return <Notification key={notification.notificationId || index} {...notification}>
                    {notification.description}
                </Notification>
            })}
        </div>
    } else {
        return <GroupedNotifications maxType={maxType} notifications={notifications} className={_className} style={style}/>
    }
};
